import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';

@Injectable()
export class ChangePasswordAdminService {

    private _endPoints = {
        changePassword: 'api/user/administrator/changePassword'
    };

    constructor(private _restApi: RestApi) { }

    public changeAdminPassword(password: string): Promise<any> {
        const url = `${this._endPoints.changePassword}`;
		const body = { password }
        return this._restApi.post(`${url}`, body).toPromise();
    }

}